module.exports = ".form-group .ng-select.opened .ng-control {\n  border-width: 0;\n  border-bottom: none !important; }\n\n.header-nav {\n  position: fixed;\n  left: 100px;\n  z-index: 3;\n  width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/vendor-setup/vendor-setup.component.scss
// module id = ./src/app/pages/vendor-setup/vendor-setup.component.scss
// module chunks = main